/* eslint-disable no-nested-ternary */
import { useTranslation } from 'react-i18next';
import { formatter } from '@repo/shared';
import { MessageCircle, ThumbsDown, ThumbsUp, User } from 'lucide-react';

import {
  useFeedbackConclusion,
  useTotalConversations,
  useUniqueUsers,
} from '@/api/generated';
import MetricCard from '@/routes/(app)/agents/components/metric-card';
import MetricSkeleton from '@/routes/(app)/agents/components/metric-skeleton';

const FeedbackMetrics = () => {
  const { t } = useTranslation();
  const { data: totalConversations, isLoading: isLoadingTotalConversations } =
    useTotalConversations();
  const { data: uniqueUsers, isLoading: isLoadingUniqueUsers } =
    useUniqueUsers();
  const { data: feedbackConclusion, isLoading: isLoadingFeedbackConclusion } =
    useFeedbackConclusion();

  return (
    <div className='grid grid-cols-3 gap-4'>
      {isLoadingTotalConversations ? (
        <MetricSkeleton />
      ) : (
        <MetricCard
          icon={<MessageCircle />}
          title={t(`feedbackAgent.metrics.totalConversations`)}
          metric={totalConversations?.metric}
        />
      )}
      {isLoadingUniqueUsers ? (
        <MetricSkeleton />
      ) : (
        <MetricCard
          icon={<User />}
          title={t(`feedbackAgent.metrics.uniqueUsers`)}
          metric={uniqueUsers?.metric}
        />
      )}
      {isLoadingFeedbackConclusion ? (
        <MetricSkeleton />
      ) : typeof feedbackConclusion?.metric === 'number' ? (
        <MetricCard
          icon={
            feedbackConclusion.metric > 0.5 ? (
              <ThumbsUp className='text-success-foreground' />
            ) : (
              <ThumbsDown className='text-destructive-foreground' />
            )
          }
          title={t(`feedbackAgent.metrics.feedbackConclusion`)}
          metric={formatter.percentage(feedbackConclusion?.metric ?? 0)}
        />
      ) : null}
    </div>
  );
};

export default FeedbackMetrics;
